import script from "./Column.vue?vue&type=script&setup=true&lang=ts"
export * from "./Column.vue?vue&type=script&setup=true&lang=ts"

import "./Column.vue?vue&type=style&index=0&id=d75dff12&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d75dff12"]])

export default __exports__